<template>
    <div id="PersonalizedCustomization">
        <view1/>
        <view2/>
        <view3/>
    </div>
</template>
<script> 
export default {
  name: 'PersonalizedCustomization',
  components: {
    // 所有子组件异步加载
    view1: () => import('@/views/PersonalizedCustomization/view1.vue'),
    view2: () => import('@/views/PersonalizedCustomization/view2.vue'),
    view3: () => import('@/views/PersonalizedCustomization/view3.vue')
  }
}
</script>
<style scoped>

</style>
